/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllGetchkdUsers, getGetchkdUserHistory } from './getchkdUserAction';
 
const initialState = {
    data: {},
    getchkdUsers: {},
    getchkdUserHistory: {}
}
const getchkdUserSlice = createSlice({
    name: 'getchkdUser',
    initialState,
    extraReducers: {

        [getAllGetchkdUsers.fulfilled]: (state, { payload }) => {
            state.getchkdUsers =  payload;
        },
        [getGetchkdUserHistory.fulfilled]: (state, { payload }) => {
            state.getchkdUserHistory =  payload;
        },
        [getGetchkdUserHistory.rejected]: (state, action) => {
            state.getchkdUserHistory =  {};
        },
    }
});

export default getchkdUserSlice.reducer